import { useState } from "react";
import { useHistory } from "react-router";
import { NavLink, Switch } from "react-router-dom";
import { Dropdown, Grid, Segment } from "semantic-ui-react";
import { logout, useCurrentUser } from "../../hooks/auth-hook";
import { useModalControl } from "../../hooks/commonHooks";
import { restRequest } from "../../http";
import { RouteWithSubRoutes } from "../../routes";
import { ChangePassword } from "../ChangePasswordComponent";
import '../../assets/scss/components/Phone.scss';

export function PhoneHome(props: { routes: any }) {
    const currentUser = useCurrentUser();
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const changePasswordModalControl = useModalControl();

    return <>

        <Segment.Group>
            <Segment>
                &nbsp;
                <Dropdown className="big left floated" labeled button icon="th">
                    <Dropdown.Menu>
                        {currentUser.permissions.analyzed_unit.view && <Dropdown.Item
                            as={NavLink} to="/phone/waive_unit"
                        >Analyzed Units</Dropdown.Item>}

                        {currentUser.permissions.issue_overview.view && <Dropdown.Item
                            as={NavLink} to="/phone/issue_overview"
                        >Testing Summary</Dropdown.Item>}

                        <Dropdown.Divider />
                        <Dropdown.Header icon='user' content={currentUser.name} />
                        <Dropdown.Item onClick={e => {
                            changePasswordModalControl.setOpen(true);
                        }}>Change Password</Dropdown.Item>
                        <Dropdown.Item onClick={e => {
                            logout().then(() => {
                                history.push('/login');
                            })
                        }}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Segment>
            <Segment>
                <Switch>
                    {props.routes.map((route: any, i: any) => (
                        <RouteWithSubRoutes key={i} {...route} />
                    ))}
                </Switch>
            </Segment>
        </Segment.Group>


        <ChangePassword modelControl={changePasswordModalControl} onFinish={result => {
            if (result) {
                changePasswordModalControl.setOpen(false);

                //force user to login again
                restRequest<any>('auth/login', null, 'get');
            }
        }}></ChangePassword>
    </>
}